import type {DeliveryProgressStep} from '../../types';

import BikeIcon from 'assets/icons/orderSteps/Bike.svg';
import LocationIcon from 'assets/icons/orderSteps/Location.svg';
import SnappIcon from 'assets/icons/orderSteps/Snapp.svg';
import StoreIcon from 'assets/icons/orderSteps/Store.svg';

export const EXPRESS_DELIVERY_STEPS: DeliveryProgressStep[] = [
  {
    title: 'سفارش در انتظار تایید فروشگاه شما',
    status: '',
    iconSrc: SnappIcon,
    percentage: 0,
    type: 'main'
  },
  {
    title: 'سفارش در حال آماده‌سازی',
    status: '',
    percentage: 17,
    type: 'line'
  },
  {
    title: 'سفارش در جست و جوی پیک',
    status: 'REQUESTED',
    iconSrc: StoreIcon,
    percentage: 34,
    type: 'main'
  },
  {
    title: 'پیک به سمت فروشگاه شما',
    status: 'ACCEPTED',
    percentage: 50,
    type: 'line'
  },
  {
    title: 'پیک در فروشگاه',
    status: 'ARRIVED_AT_PICKUP',
    iconSrc: BikeIcon,
    percentage: 67,
    type: 'main'
  },
  {
    title: 'سفارش به پیک تحویل داده شد و به زودی به دست مشتری می‌رسد.',
    status: 'PICKED_UP',
    percentage: 78,
    type: 'line'
  },
  {
    title: 'سفارش در حال تحویل',
    status: 'ARRIVED_AT_DROP_OFF',
    percentage: 89,
    type: 'line'
  },
  {
    title: 'سفارش تحویل داده شد',
    status: 'DELIVERED',
    iconSrc: LocationIcon,
    percentage: 100,
    type: 'main'
  },
  {
    title: 'کنسل شده توسط سیستم',
    status: 'CANCELED_BY_API',
    iconSrc: LocationIcon,
    percentage: 100,
    type: 'line'
  }
];

export const OWN_DELIVERY_STEPS: DeliveryProgressStep[] = [
  {
    title: 'سفارش در انتظار تایید فروشگاه شما',
    status: '',
    iconSrc: SnappIcon,
    percentage: 0,
    type: 'main'
  },
  {
    title: 'سفارش در حال آماده‌سازی',
    status: '',
    iconSrc: StoreIcon,
    percentage: 50,
    type: 'main'
  },
  {
    title: 'سفارش به پیک تحویل داده شد و به زودی به دست مشتری می‌رسد.',
    status: 'PICKED_UP',
    percentage: 75,
    type: 'line'
  },
  {
    title: 'سفارش در حال تحویل',
    status: 'ARRIVED_AT_DROP_OFF',
    percentage: 88,
    type: 'line'
  },
  {
    title: 'سفارش تحویل داده شد',
    status: 'DELIVERED',
    iconSrc: LocationIcon,
    percentage: 100,
    type: 'main'
  },
  {
    title: 'کنسل شده توسط سیستم',
    status: 'CANCELED_BY_API',
    iconSrc: LocationIcon,
    percentage: 100,
    type: 'line'
  }
];
